  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
//import Popover                                             from '@material-ui/core/Popover';
//import IconButton                                          from '@material-ui/core/IconButton';
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import Typography                                          from '@material-ui/core/Typography';
//import InfoIcon                                            from '@material-ui/icons/Info';
  //-------------------
  // @material-ui/icons
  //-------------------
//import CardTravel                                          from "@material-ui/icons/CardTravel";
//import Extension                                           from "@material-ui/icons/Extension";
//import Fingerprint                                         from "@material-ui/icons/Fingerprint";
//import FlightLand                                          from "@material-ui/icons/FlightLand";
//import Build                                               from "@material-ui/icons/Build";
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import TagManager                                          from 'react-gtm-module'
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_IdentityCardsService }                         from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
//import { wu_GeolocationService }                           from "../../_services";
//import { wu_RegisterGOVService }                           from "../../_services";
//import { wu_RegisterIdBoxService }                         from "../../_services";
  //------
  // Style
  //------
  import SettingsProfileIdDetailsStyle                       from "./SettingsProfileIdDetailsStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "SettingsProfileIdDetails ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[flagsimages]
  var images = null;

class SettingsProfileIdDetails extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      SettingsProfileIdDetails_viewInfo_lbl_lbl1           : "",

      idIssuingCountry_id                                  : "",               //DropDown
      idIssuingCountry_text                                : "",
      idIssuingCountry_disabled                            : false,
      idIssuingCountry_hasError                            : false,
      idType_text                                          : "",               //DropDown
      idType_id                                            : "",
      idType_disabled                                      : false,
      idType_hasError                                      : false,
      idNumber                                             : "",               //TextField
      idNumber_disabled                                    : false,
      idNumber_hasError                                    : false,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getIdTypes_el                           : [],
      parserObject_getIdTypes_en                           : [],
      parserObject_getIdTypes4Picker_el                    : [],
      parserObject_getIdTypes4Picker_en                    : [],
      parserObject_getPhonePrefixes                        : [],
      parserObject_getPhonePrefixes4Picker                 : [],

      btn_next_text                                        : "",
      btn_next_isHidden                                    : true,

      redirectURL                                          : "", //GOV info
      languageCode                                         : "",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                              = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                             = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                     = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                    = this.Snackbar_textField_handleClose.bind(this);

    this.btn_next_act                                      = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                           = this.btn_next_act_isDisabled.bind(this);

    this.handleSubmit_with_recaptcha                       = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                      = React.createRef();

    this.handleCustomDropDownClick_idIssuingCountry        = this.handleCustomDropDownClick_idIssuingCountry.bind(this);
    this.handleCustomDropDownClick_idType                  = this.handleCustomDropDownClick_idType.bind(this);

    this.buttons_show_hide                                 = this.buttons_show_hide.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        //++++++++++++
        //Login Screen
        //++++++++++++
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsProfileIdDetails"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    var res_obj_getPhonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    var parserObject_getPhonePrefixes4Picker = [];
    let descKey_phonePrefixes = localStorage.getItem("lang")==="el" ? "descr_el" : "descr_en";
    for(let i=0; i<res_obj_getPhonePrefixes.phone_prefixes.length; ++i){ parserObject_getPhonePrefixes4Picker.push(res_obj_getPhonePrefixes.phone_prefixes[i][descKey_phonePrefixes]); }
    this.setState({
      "parserObject_getPhonePrefixes"        : res_obj_getPhonePrefixes.phone_prefixes,
      "parserObject_getPhonePrefixes4Picker" : parserObject_getPhonePrefixes4Picker,
    });

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="SettingsProfileIdDetails"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}

      let btn_next_isHidden = false;

      let aTextDecision = wu_Utilities.textDecisions_SettingsProfileId(api.print_logs,parserObject_validatecustomer);

      var SettingsProfileIdDetails_viewInfo_lbl_lbl1 = "";
      if(aTextDecision === "OK")         { SettingsProfileIdDetails_viewInfo_lbl_lbl1 = this.NSInforString("SettingsProfileIdDetails_viewInfo_lbl_lbl1_ok");          }
      if(aTextDecision === "changeId")   { SettingsProfileIdDetails_viewInfo_lbl_lbl1 = this.NSInforString("SettingsProfileIdDetails_viewInfo_lbl_lbl1_changeId");    }
      if(aTextDecision === "newCustomer"){ SettingsProfileIdDetails_viewInfo_lbl_lbl1 = this.NSInforString("SettingsProfileIdDetails_viewInfo_lbl_lbl1_newCustomer"); }
      var btn_next_text = "";
      if(aTextDecision === "OK")         { btn_next_text = this.NSInforString("SettingsProfileIdDetails_btn_next_ok");          }
      if(aTextDecision === "changeId")   { btn_next_text = this.NSInforString("SettingsProfileIdDetails_btn_next_changeId");    }
      if(aTextDecision === "newCustomer"){ btn_next_text = this.NSInforString("SettingsProfileIdDetails_btn_next_newCustomer"); }


      let ws_idnum   = "";
      let ws_id_ctry = "";
      let ws_idtype  = "";
      let ws_idNew   = false;
      try {ws_idnum   = res.customer["idnum"];   }catch(err){;} if(ws_idnum   === null || (typeof ws_idnum   ==="undefined")){ws_idnum   = "";}
      try {ws_id_ctry = res.customer["id_ctry"]; }catch(err){;} if(ws_id_ctry === null || (typeof ws_id_ctry ==="undefined")){ws_id_ctry = "";}
      try {ws_idtype  = res.customer["idtype"];  }catch(err){;} if(ws_idtype  === null || (typeof ws_idtype  ==="undefined")){ws_idtype  = "";}
      try {ws_idNew   = res.customer["idtype"];  }catch(err){;} if(ws_idNew   === null || (typeof ws_idNew   ==="undefined")){ws_idNew   = false;}
      this.setState({
        SettingsProfileIdDetails_viewInfo_lbl_lbl1           : SettingsProfileIdDetails_viewInfo_lbl_lbl1,

        idIssuingCountry_id                                  : ws_id_ctry,
        idIssuingCountry_text                                : wu_Utilities.findCountryNameFromCountryId(ws_id_ctry,localStorage.getItem("lang")),
        idIssuingCountry_disabled                            : true,
        idType_id                                            : "",
        idType_text                                          : "", //DropDown
        idType_disabled                                      : true,
        idType_hasError                                      : false,
        idNumber                                             : ws_idnum,
        idNumber_disabled                                    : true,

        btn_next_text                                        : btn_next_text,
        btn_next_isHidden                                    : btn_next_isHidden,
      });

      this.makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE(ws_id_ctry,ws_idtype,ws_idNew);
    })
    .catch(err => {
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    const defaultPropsCountry = {
      options        : this.state.parserObject_getCountries4Picker,
      getOptionLabel : option => option,
    };

    var lang = localStorage.getItem("lang");
    var parserObject_getIdTypes4Picker       = (lang==="el") ? this.state.parserObject_getIdTypes4Picker_el   : this.state.parserObject_getIdTypes4Picker_en;
    var idType_text                          = this.translate_idtype(   lang,this.state.idType_id,         this.state.idType_text);
    //console.log(methName+"idType_text            = "+idType_text);
    //onsole.log(methName+"this.state.idType_id   = "+this.state.idType_id);
    //console.log(methName+"this.state.idType_text = "+this.state.idType_text);

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
  //let btn_next_isHidden = false;
    let aTextDecision = wu_Utilities.textDecisions_SettingsProfileId(api.print_logs,parserObject_validatecustomer);
    var SettingsProfileIdDetails_viewInfo_lbl_lbl1 = "";
    if(aTextDecision === "OK")         { SettingsProfileIdDetails_viewInfo_lbl_lbl1 = this.NSInforString("SettingsProfileIdDetails_viewInfo_lbl_lbl1_ok");          }
    if(aTextDecision === "changeId")   { SettingsProfileIdDetails_viewInfo_lbl_lbl1 = this.NSInforString("SettingsProfileIdDetails_viewInfo_lbl_lbl1_changeId");    }
    if(aTextDecision === "newCustomer"){ SettingsProfileIdDetails_viewInfo_lbl_lbl1 = this.NSInforString("SettingsProfileIdDetails_viewInfo_lbl_lbl1_newCustomer"); }
    var btn_next_text = "";
    if(aTextDecision === "OK")         { btn_next_text = this.NSInforString("SettingsProfileIdDetails_btn_next_ok");          }
    if(aTextDecision === "changeId")   { btn_next_text = this.NSInforString("SettingsProfileIdDetails_btn_next_changeId");    }
    if(aTextDecision === "newCustomer"){ btn_next_text = this.NSInforString("SettingsProfileIdDetails_btn_next_newCustomer"); }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("SettingsProfileIdDetails_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("SettingsProfileIdDetails_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <div>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.label1}>{SettingsProfileIdDetails_viewInfo_lbl_lbl1}</div>
                  <div style={{ marginBottom:10 }}></div>
                </GridItem>
              </GridContainer>

              <GridContainer justify="center">
                {/* ------------------------- */}
                {/* ----------[HONEYMOON]---- */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete={this.autoCompleteText_Textfields()}
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classes.idIssuingCountry}>
                    <Autocomplete
                      {...defaultPropsCountry}
                      id="idIssuingCountry"
                      value={this.state.idIssuingCountry_text}
                      disableClearable
                      disabled={this.state.idIssuingCountry_disabled}
                      onChange={(event,value) => this.handleCustomDropDownClick_idIssuingCountry(event,value)}
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params => <TextField {...params} error={this.state.idIssuingCountry_hasError} label={this.NSInforString("SettingsProfileIdDetails_plh02")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                    />
                  </FormControl>
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.idType_hasError} className={classes.idType}>
                    <InputLabel id="idType_InputLabel">{this.NSInforString("SettingsProfileIdDetails_plh03")}</InputLabel>
                    <Select
                      disabled={this.state.idType_disabled}
                      displayEmpty
                      id="idType"
                      value={idType_text+""}
                      onChange={event => this.handleCustomDropDownClick_idType(event)}
                    >
                      {parserObject_getIdTypes4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                {/* ------------------------- */}
                {/* ----------ROW------------ */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error   ={this.state.idNumber_hasError}
                    disabled={this.state.idNumber_disabled}
                    className={classes.idNumber}
                    id="idNumber"
                    label={this.NSInforString("SettingsProfileIdDetails_plh04")}
                    value={this.state.idNumber}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "idNumber"),
                      type: "text"
                    }}
                  />
                </GridItem>
              </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              {this.state.btn_next_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    {/* <div className={classes.labelHeader}>&nbsp;</div> */}
                    <div className={classes.textCenter}>
                      {/* <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={ this.btn_next_act } /> */}
                      <CustomButton
                        disabled={this.btn_next_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_next_act}
                        type="submit">
                        {btn_next_text}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              )}
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("SettingsProfileIdDetails_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) }
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        <GridContainer justify="center">
          <form id="govRedirectForm" action={api.url_onlinemt+api.webapp_path+"/gov/wbwu/redirect"} method="post">
            <GridItem xs={10} sm={10} md={10}>
              {/* GOV Payment info */}
              <input type="hidden" id="redirectURL"                    name="redirectURL"                    value={this.state.redirectURL}/>
              <input type="hidden" id="languageCode"                   name="languageCode"                   value={this.state.languageCode}/>
              {/* Session between domains : webapp & mobile */}
              <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
              <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/>
              {/* Session between domains : webapp */}
              <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
              <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
            </GridItem>
          </form>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_idIssuingCountry(event,value) {
    let methName = filename+"handleCustomDropDownClick_idIssuingCountry ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "idIssuingCountry_text"     : eventTMP,
      "idIssuingCountry_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP){
        this.setState({ "idIssuingCountry_id": this.state.parserObject_getCountries[i].ctry_wu_id });

        setTimeout(function() {
          this.buttons_show_hide();
          this.makeHTTPConn_select_COUNTRY_reload_IDTYPE(this.state.parserObject_getCountries[i].ctry_wu_id);
        }.bind(this), 500);
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_idType(event) {
    let methName = filename+"handleCustomDropDownClick_idType ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "idType_text" : eventTMP });
    if(localStorage.getItem("lang")==="el"){
      for(let i=0; i<this.state.parserObject_getIdTypes4Picker_el.length; ++i){
        if(this.state.parserObject_getIdTypes4Picker_el[i]===eventTMP){
          this.setState({
            "idType_id"       : this.state.parserObject_getIdTypes_el[i].id,
            "idType_hasError" : false,
          });
          break;
        }
      }
    }
    else{
      for(let i=0; i<this.state.parserObject_getIdTypes4Picker_en.length; ++i){
        if(this.state.parserObject_getIdTypes4Picker_en[i]===eventTMP){
          this.setState({
            "idType_id"       : this.state.parserObject_getIdTypes_en[i].id,
            "idType_hasError" : false,
          });
          break;
        }
      }
    }

    setTimeout(function() {
      this.buttons_show_hide();
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text.trim() === "")   { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; }
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError" : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_next_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  translate_idtype(lang,idType_id,idType_text){
    if(lang==="el"){
      for(let i=0; i<this.state.parserObject_getIdTypes_el.length; ++i){ if(this.state.parserObject_getIdTypes_el[i]["id"]===idType_id){ return this.state.parserObject_getIdTypes_el[i]["description"] } }
    }
    else{
      for(let i=0; i<this.state.parserObject_getIdTypes_en.length; ++i){ if(this.state.parserObject_getIdTypes_en[i]["id"]===idType_id){ return this.state.parserObject_getIdTypes_en[i]["descriptionEn"] } }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.idIssuingCountry_text.trim() === "")   { this.setState({"idIssuingCountry_hasError" : true }); emptyFields = true; }
      if(this.state.idType_id === "")                      { this.setState({"idType_hasError" : true }); emptyFields = true; }
      if(this.state.idNumber.trim() === "")                { this.setState({"idNumber_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){console.log("emptyFields===true");if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //---------------
    //validate idctry---Picker
    //---------------
    let idctry = this.state.idIssuingCountry_id;
    if(idctry  === ""){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfileIdDetails_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.idIssuingCountry_text === this.NSInforString("SettingsProfileIdDetails_plh02")){
      this.setState({"idIssuingCountry_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfileIdDetails_plh02"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //---------------
    //validate idtype---Picker
    //---------------
    let idtype = this.state.idType_id;
    let idType_text = this.state.idType_text;
    if(idtype  === ""){
      this.setState({"idType_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("SettingsProfileIdDetails_plh03"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate idnum---TextField
    //--------------
    let idnum = this.state.idNumber.trim();
    if(idnum  === ""){
      this.setState({"idNumber_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("SettingsProfileIdDetails_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    var email = "";
    try {email = parserObject_validatecustomer["email"]; }catch(err){;} if(email === null){email = "";}

    //event.preventDefault();

    if(api.print_logs){console.log(methName+"idctry      = "+idctry);}
    if(api.print_logs){console.log(methName+"idType_text = "+idType_text);}

    //try { localStorage.setItem("idBoxFlow","WorldBridgeNoVideo"); } catch(err){;}
    try { localStorage.setItem("newRegistrationFlow","changeId"); } catch(err){;}
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
    history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------makeHTTPConn--------------------------------------
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_IDTYPE(idIssuingCountry_id){
      let methName = filename+"makeHTTPConn_select_COUNTRY_reload_IDTYPE ";

      if(idIssuingCountry_id===null || (typeof idIssuingCountry_id ==="undefined") || idIssuingCountry_id.trim()===""){
        return;
      }
      //-------------
      //wu_getIdTypes
      //-------------
      wu_IdentityCardsService
      .wu_getIdTypes({issuecountryid:idIssuingCountry_id})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsProfileIdDetails"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        var parserObject_getIdTypes4Picker_el = [];
        var parserObject_getIdTypes4Picker_en = [];
        let descKey_idTypes_el = "description"
        let descKey_idTypes_en = "descriptionEn";
        for(var i=0; i<res.idType.length; ++i){ parserObject_getIdTypes4Picker_el.push(res.idType[i][descKey_idTypes_el]); }
        for(var j=0; i<res.idType.length; ++j){ parserObject_getIdTypes4Picker_en.push(res.idType[j][descKey_idTypes_en]); }
        this.setState({ "parserObject_getIdTypes_el" : res.idType });
        this.setState({ "parserObject_getIdTypes_en" : res.idType });
        this.setState({
          "parserObject_getIdTypes4Picker_el"          : parserObject_getIdTypes4Picker_el,
          "parserObject_getIdTypes4Picker_en"          : parserObject_getIdTypes4Picker_en,
          "idType_id"                                  : "",
          "idType_text"                                : "",
          "idType_hasError"                            : false,
        });
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });

      return;
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE(idIssuingCountry_id,idtype,idNew){
      let methName = filename+"makeHTTPConn_select_COUNTRY_reload_IDTYPE_select_IDTYPE ";

      if(api.print_logs){console.log(methName+"idIssuingCountry_id = "+idIssuingCountry_id);}
      if(api.print_logs){console.log(methName+"idtype              = "+idtype);             }

      if(idIssuingCountry_id==="" || (idIssuingCountry_id === null || (typeof idIssuingCountry_id ==="undefined")) ){
        console.log(methName+"return...idIssuingCountry_id = "+idIssuingCountry_id);
        return;
      }

      //let idtypeId = "";
      //-------------
      //wu_getIdTypes
      //-------------
      wu_IdentityCardsService
      .wu_getIdTypes({issuecountryid:idIssuingCountry_id})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsProfileIdDetails"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(res.returnCode===0){
          var parserObject_getIdTypes4Picker_el = [];
          var parserObject_getIdTypes4Picker_en = [];
          let descKey_idTypes_el = "description";
          let descKey_idTypes_en = "descriptionEn";
          for(let i=0; i<res.idType.length; ++i){ parserObject_getIdTypes4Picker_el.push(res.idType[i][descKey_idTypes_el]); }
          for(let i=0; i<res.idType.length; ++i){ parserObject_getIdTypes4Picker_en.push(res.idType[i][descKey_idTypes_en]); }
          this.setState({ "parserObject_getIdTypes_el": res.idType });
          this.setState({ "parserObject_getIdTypes_en": res.idType });
          this.setState({
            "parserObject_getIdTypes4Picker_el" : parserObject_getIdTypes4Picker_el,
            "parserObject_getIdTypes4Picker_en" : parserObject_getIdTypes4Picker_en,
            "idType_id"                         : "",
            "idType_text"                       : "",
            "idType_hasError"                   : false,
          });
          //---
          for(let i=0;  i<res.idType.length; ++i){
            //console.log("idtype="+idtype+"-"+res.idType[i]["description"]+"-"+res.idType[i]["descriptionEn"]);
            if(idNew===true){
              let descKey_idTypes = localStorage.getItem("lang")==="el" ? "description" : "descriptionEn";
              //idtypeId = res.idType[i]["id"];
              console.log("idtype="+idtype+"-"+res.idType[i][descKey_idTypes]);
              this.setState({
                "parserObject_getIdTypes4Picker_el" : parserObject_getIdTypes4Picker_el,
                "parserObject_getIdTypes4Picker_en" : parserObject_getIdTypes4Picker_en,
                "idType_id"                         : res.idType[i]["id"],
                "idType_text"                       : res.idType[i][descKey_idTypes],
                "idType_hasError"                   : false,
              });
            }
            else{
              if(idtype===res.idType[i]["description"] || idtype===res.idType[i]["descriptionEn"]){
                let descKey_idTypes = localStorage.getItem("lang")==="el" ? "description" : "descriptionEn";
                //idtypeId = res.idType[i]["id"];
                console.log("idtype="+idtype+"-"+res.idType[i][descKey_idTypes]);
                this.setState({
                  "parserObject_getIdTypes4Picker_el" : parserObject_getIdTypes4Picker_el,
                  "parserObject_getIdTypes4Picker_en" : parserObject_getIdTypes4Picker_en,
                  "idType_id"                         : res.idType[i]["id"],
                  "idType_text"                       : res.idType[i][descKey_idTypes],
                  "idType_hasError"                   : false,
                });
              }
            }
          }
          let numPages              = 2;
          let optionalMultiplePages = 0;
          for(let i=0; i<res.idType.length; ++i){
              try {numPages              = res.idType[i]["numPages"];              }catch(err){;} if(numPages              === null || (typeof numPages              ==="undefined")){numPages              = 2; }
              try {optionalMultiplePages = res.idType[i]["optionalMultiplePages"]; }catch(err){;} if(optionalMultiplePages === null || (typeof optionalMultiplePages ==="undefined")){optionalMultiplePages = 0; }
              if(idNew===true){
                if(api.print_logs){console.log(methName+"ScanDocuments_items_num             = "+numPages.toString());}
                if(api.print_logs){console.log(methName+"ScanDocuments_optionalMultiplePages = "+optionalMultiplePages.toString());}
                localStorage.setItem("ScanDocuments_items_num",numPages.toString());
                localStorage.setItem("ScanDocuments_optionalMultiplePages",optionalMultiplePages.toString());
              }
              else{
                if(idtype===res.idType[i]["description"] || idtype===res.idType[i]["descriptionEn"]){
                    if(api.print_logs){console.log(methName+"ScanDocuments_items_num             = "+numPages.toString());}
                    if(api.print_logs){console.log(methName+"ScanDocuments_optionalMultiplePages = "+optionalMultiplePages.toString());}
                    localStorage.setItem("ScanDocuments_items_num",numPages.toString());
                    localStorage.setItem("ScanDocuments_optionalMultiplePages",optionalMultiplePages.toString());
                }
              }
          }
          setTimeout(function() {
            this.buttons_show_hide();
          }.bind(this), 500);
        }
      })
      .catch(err => {
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });

      return;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="idNumber"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "idNumber"            : eventTMP,
        "idNumber_hasError"   : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"idNumber_hasError":true}); return; }
    }
    else{
      this.setState({ [stateVar] : eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  //https://stackoverflow.com/questions/21188420/javascript-date-validation-not-validation-february-31
  isValidDate(year, month, day) {
    let methName = filename+"isValidDate ";
    if(api.print_logs){console.log(methName);}

    try{
      let year_int  = parseInt(year);
      let month_int = parseInt(month)-1;
      let day_int   = parseInt(day);
      var d = new Date(year_int, month_int, day_int);
      //console.log(methName+"d.getFullYear()="+d.getFullYear()+" year_int="+year_int);
      //console.log(methName+"d.getMonth()   ="+d.getMonth()+"    month_int="+month_int);
      //console.log(methName+"d.getDate()    ="+d.getDate()+"     day_int="+day_int);
      if (d.getFullYear() === year_int && d.getMonth() === month_int && d.getDate() === day_int) {
          return true;
      }
    }catch(err){
      console.log(methName+"err="+err)
      return false;
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG3"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Specific------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  buttons_show_hide() {
    let methName = filename+"buttons_show_hide ";
    if(api.print_logs){console.log(methName);}

    //let parserObject_validatecustomer = {};
    //try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}

    if(api.print_logs){console.log(methName+"this.state.idIssuingCountry_id = "+this.state.idIssuingCountry_id);}
    if(api.print_logs){console.log(methName+"this.state.idType_text         = "+this.state.idType_text);}

    //let idIssuingCountry_disabled = false;
    //let idType_disabled           = false;
    //let idNumber_disabled         = false;
    let btn_next_isHidden         = false;
    this.setState({
      //idIssuingCountry_disabled : idIssuingCountry_disabled,
      //idType_disabled           : idType_disabled,
      //idNumber_disabled         : idNumber_disabled,

      btn_next_isHidden         : btn_next_isHidden,
    });
  }
  //----------------------------------------------------------------------------------------------------
}
SettingsProfileIdDetails.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(SettingsProfileIdDetailsStyle)(SettingsProfileIdDetails)
);
